<template>
  <div class="bda">
    <div class="bda-head">
      <span class="bda-head__bar" />
      <span class="bda-head__title">工作动态</span>
    </div>
    <div class="bda-body">
      <div
        v-for="(item, i) in displayItems"
        :key="item.id || i"
        class="bda-row"
        :class="{'bda-row--empty': !item.id}"
      >
        <span class="bda-row__time">{{ item.formatted_time || '' }}</span>
        <span v-if="item.id" class="bda-row__dot" :class="'bda-row__dot--' + item.module" />
        <span v-else class="bda-row__dot bda-row__dot--empty" />
        <div class="bda-row__main">
          <span v-if="item.id" class="bda-row__user">{{ item.user_name }}</span>
          <span class="bda-row__text">{{ item.summary || '—' }}</span>
          <span v-if="item.project_name" class="bda-row__proj">{{ item.project_name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {USE_MOCK, mockActivities} from './bid-dashboard-mock';
import {ACTIVITY_SIZE} from './bid-dashboard-theme';

export default {
  data() {
    return {items: []};
  },
  computed: {
    displayItems() {
      const list = this.items.slice(0, ACTIVITY_SIZE);
      while (list.length < ACTIVITY_SIZE) list.push({});
      return list;
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      if (USE_MOCK) {
        this.items = mockActivities();
        return;
      }
      this.$api.get('/business/bid/dashboard/activities', {limit: ACTIVITY_SIZE}).then((res) => {
        this.items = res.data.data || [];
      }).catch(() => {
        this.items = mockActivities();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.bda {
  height: 100%;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #c5ddf5;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.bda-head {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-bottom: 1px solid #eef4fc;
  flex-shrink: 0;
}

.bda-head__bar {
  width: 3px;
  height: 11px;
  background: #1a6fd4;
  border-radius: 2px;
}

.bda-head__title {
  font-size: 13px;
  font-weight: 700;
  color: #1e3a5f;
}

.bda-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 2px 0;
}

.bda-row {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 8px;
  border-bottom: 1px dashed #eef4fc;
  min-height: 0;

  &:last-child { border-bottom: none; }
  &--empty { opacity: 0.25; }
}

.bda-row__dot--empty {
  background: #eef4fc;
}

.bda-row__time {
  min-width: 68px;
  flex-shrink: 0;
  font-size: 9px;
  color: #6b8aad;
  text-align: right;
  white-space: nowrap;
  line-height: 1;
}

.bda-row__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #1a6fd4;
  flex-shrink: 0;

  &--open { background: #d97706; }
  &--work { background: #0d4a8f; }
}

.bda-row__main {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
}

.bda-row__user {
  font-weight: 700;
  color: #1a6fd4;
  flex-shrink: 0;
}

.bda-row__text {
  color: #1e3a5f;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
}

.bda-row__proj {
  flex-shrink: 0;
  max-width: 36%;
  font-size: 10px;
  color: #9cb8d8;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
